module.exports = __webpack_public_path__ + "static/media/tigo-logo.f526ab13.png";